import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

export default function DigestSettings({ status, onChange }) {
  const [sending, setSending] = useState(false);
  const [enabled, setEnabled] = useState(status.digest_enabled ?? true);

  const toggle = async (v) => {
    setEnabled(v);
    try {
      await api.post("/digest/settings", { enabled: v });
      toast.success(v ? "Nightly brief emails on" : "Nightly brief emails off");
      onChange?.();
    } catch {
      setEnabled(!v);
      toast.error("Couldn't save setting");
    }
  };

  const sendNow = async () => {
    setSending(true);
    try {
      await api.post("/digest/send-now");
      toast.success("Brief sent — check your inbox");
      onChange?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Send failed");
    } finally {
      setSending(false);
    }
  };

  if (!status.connected) return null;

  return (
    <div className="mt-4 pt-4 border-t border-dashed border-[#282C30]" data-testid="digest-settings">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm text-[#F4F1EA]">Nightly brief by email</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#606872] mt-0.5 truncate" data-testid="digest-status-text">
            {!status.can_send
              ? "Reconnect Gmail to grant send permission"
              : status.digest_last_sent_at
              ? `Last sent ${new Date(status.digest_last_sent_at).toLocaleString()}`
              : "Sends from your Gmail at 2:00 UTC"}
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={toggle} data-testid="digest-toggle" />
      </div>
      <Button variant="outline" className="btn-outline-paper w-full h-8 mt-3 text-xs" onClick={sendNow} disabled={sending || !status.can_send} data-testid="digest-send-now-button">
        {sending ? <><Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> Sending…</> : <><Send className="h-3.5 w-3.5 mr-1" /> Send me tonight's brief now</>}
      </Button>
    </div>
  );
}
